import styled, { css } from 'styled-components';
import { Flex } from '@finect/tabular-core/Flex';
import { Strong } from '@finect/tabular-core/Strong';
import { getFont } from '@finect/tabular-utils/getFont';
export var TooltipContainer = styled.div.withConfig({
  displayName: "partials__TooltipContainer",
  componentId: "sc-5j5ogc-0"
})(["margin-left:4px;> ", "{color:", ";svg{width:12px;height:12px;}}"], Flex, function (_ref) {
  var theme = _ref.theme;
  return theme.colors.uiD;
});
var visibleStyles = css(["display:block;opacity:1;"]);
export var TipWrapper = styled.div.withConfig({
  displayName: "partials__TipWrapper",
  componentId: "sc-5j5ogc-1"
})(["position:absolute;"]);
export var Tip = styled.div.withConfig({
  displayName: "partials__Tip",
  componentId: "sc-5j5ogc-2"
})(["display:none;position:absolute;z-index:4;left:-50%;opacity:0;width:240px;padding:9px 12px;border:1px solid ", ";border-radius:", ";box-shadow:0 4px 16px 0 rgb(46 46 51 / 15%);background-color:#fff;white-space:normal;text-align:left;transform:translate(-50%,0);transition:opacity 0.5s ease;", " ", "{display:block;margin-bottom:3px;", "}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.uiL;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.borderRadius;
}, function (_ref4) {
  var isVisible = _ref4.isVisible;
  return isVisible && visibleStyles;
}, Strong, getFont(-1));
export var ViewMoreBlock = styled.div.withConfig({
  displayName: "partials__ViewMoreBlock",
  componentId: "sc-5j5ogc-3"
})(["margin-top:6px;"]);